<template>
  <nav class="nav-menu">
    <div class="logo">
      <img src="@/assets/logo.png" alt="鲸鱼Logo" />
      <!-- <span>鲸鱼</span> -->
    </div>
    <ul class="menu-items" :class="{ 'lang-en': currentLanguage === 'en' }">
      <li v-for="(item, index) in menuItems" :key="index">
        <a
          :href="`#${item.index}`"
          @click.prevent="handleSelect(item.index)"
          :class="{ active: activeIndex === item.index }"
        >
          {{ $t(item.labelKey) }}
        </a>
        <!-- <ul v-if="item.children.length > 0" class="submenu">
          <li v-for="(child, childIndex) in item.children" :key="childIndex">
            <a :href="`#${item.index}-${childIndex}`" @click.prevent="handleSelect(`${item.index}-${childIndex}`)">
              {{ child.label }}
            </a>
          </li>
        </ul> -->
      </li>
    </ul>
    <LanguageSwitcher />
  </nav>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue';

export default {
  components: {
    LanguageSwitcher,
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
  },
  data() {
    return {
      menuItems: [
        { labelKey: 'nav.home', index: '0', children: [], route: '/' },
        { labelKey: 'nav.intro', index: '1', children: [], route: '/intro' },
        { labelKey: 'nav.market', index: '2', children: [], route: '/market' },
        { labelKey: 'nav.tech', index: '3', children: [], route: '/tech' },
        {
          labelKey: 'nav.aiQuant',
          index: '4',
          children: [],
          route: null,
          comingSoon: true,
        },
        {
          labelKey: 'nav.chainGame',
          index: '5',
          children: [],
          route: null,
          comingSoon: true,
        },
        {
          labelKey: 'nav.nft',
          index: '6',
          children: [],
          route: null,
          comingSoon: true,
        },
        // { labelKey: 'nav.static', index: '7', children: [], route: '/static' },
        {
          labelKey: 'nav.dynamic',
          index: '8',
          children: [],
          route: '/dynamic',
        },
        {
          labelKey: 'nav.roadmap',
          index: '9',
          children: [],
          route: '/roadmap',
        },
      ],
      activeIndex: '0',
    };
  },
  methods: {
    handleSelect(key) {
      const selectedItem = this.menuItems.find((item) => item.index === key);
      if (selectedItem && selectedItem.comingSoon) {
        // 显示待开放提示
        this.$message({
          message: this.$t('common.comingSoon'),
          type: 'info',
          duration: 2000,
        });
        return;
      }
      if (selectedItem && selectedItem.route) {
        this.activeIndex = key;
        this.$router.push(selectedItem.route);
      }
    },
  },
  watch: {
    $route(to) {
      // 根据当前路由更新激活的菜单项
      const currentItem = this.menuItems.find((item) => item.route === to.path);
      if (currentItem) {
        this.activeIndex = currentItem.index;
      }
    },
  },
  mounted() {
    // 初始化时设置激活的菜单项
    const currentItem = this.menuItems.find(
      (item) => item.route === this.$route.path
    );
    if (currentItem) {
      this.activeIndex = currentItem.index;
    }
    // 监听语言切换事件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    this.$root.$off('language-changed');
  },
};
</script>

<style scoped>
.nav-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(10, 14, 39, 0.95);
  backdrop-filter: blur(10px);
  padding: 10px 20px;
  position: relative;
  border-bottom: 1px solid var(--border-color);
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  width: 130px;
  height: 40px;
  margin-right: 10px;
}

.menu-items {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.menu-items li {
  position: relative;
}

.menu-items a {
  display: block;
  color: var(--text-secondary);
  text-decoration: none;
  padding: 15px 20px;
  transition: all 0.3s ease;
  font-size: 16px;
  white-space: nowrap;
}

/* 英文状态下缩小菜单字体和间距 */
.menu-items.lang-en a {
  font-size: 13px;
  padding: 15px 12px;
}

.menu-items a:hover,
.menu-items a.active {
  color: var(--accent-light);
  border-bottom: 2px solid var(--accent-primary);
}

.has-children a {
  padding-right: 30px;
}

.has-children a::after {
  content: '▼';
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.submenu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  min-width: 200px;
  box-shadow: var(--shadow-dark);
  background-color: var(--bg-card);
  border: 1px solid var(--border-color);
  z-index: 100;
}

.submenu li {
  position: relative;
}

.submenu a {
  padding: 10px 20px;
}

.submenu a {
  color: var(--text-secondary);
}

.submenu a:hover,
.submenu a.active {
  background-color: var(--accent-primary);
  color: var(--text-primary);
}

.has-children:hover .submenu {
  display: block;
}
</style>
